// src/store/slices/applicationRequestsSlice.js

import { createSlice } from "@reduxjs/toolkit";
import {
    fetchApplicationRequests,
    updateApplicationRequest
} from "./applicationRequestsThunk";

const initialState = {
    applicationRequestsData: [],
    // updateAdmissionTest: [],
    totalRecords: 0,
    totalPages:0,
    loading: false,
    error: null,
};

const applicationRequestsSlice = createSlice({
    name: "admissionTests",
    initialState,
    reducers: {
        clearApplicationRequestsError(state) {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // ── fetchapplicationRequests ─────────────────────────────────────────
            .addCase(fetchApplicationRequests.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchApplicationRequests.fulfilled, (state, action) => {
                state.loading = false;
                state.applicationRequestsData = action.payload?.data;
                state.totalRecords = action.payload?.count;
                state.totalPages = action.payload?.totalPages;
            })
            .addCase(fetchApplicationRequests.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
          .addCase(updateApplicationRequest.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(updateApplicationRequest.fulfilled, (state, action) => {
            state.loading = false;
          })
          .addCase(updateApplicationRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error.message;
          })
    },
});

export const { clearApplicationRequestsError } = applicationRequestsSlice.actions;
export default applicationRequestsSlice.reducer;
